export default {
    namespaced: true,
    state: {
        promotions: [],
        userClaimedPromotions: [],
        userActivePromotions: [],
        turnOverAmount: {
            minimum_turn_over_amount: 0,
            current_turn_over_amount: 0,
        },
        isPromotionsFetching: false,
    },
    mutations: {
        SET_PROMOTIONS(state, promotions) {
            state.promotions = promotions;
        },
        SET_IS_PROMOTIONS_FETCHING(state, status) {
            state.isPromotionsFetching = status;
        },
        SET_USER_CLAIMED_PROMOTIONS(state, promotions) {
            state.userClaimedPromotions = promotions;
        },
        SET_USER_ACTIVE_PROMOTIONS(state, promotions) {
            state.userActivePromotions = promotions;
        },
        SET_TURNOVER_AMOUNT(state, turnOverAmount) {
            state.turnOverAmount = turnOverAmount;
        },
    },
    actions: {
        async fetchActivePromotions({ commit }) {
            commit('SET_IS_PROMOTIONS_FETCHING', true);
            try {
                const res = await axios.get('/active-promotions', {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('token')}`,
                    },
                });
                commit("SET_PROMOTIONS", res.data.data);
            } catch (error) {
                throw new Error('Failed to fetch promotions');
            } finally {
                commit('SET_IS_PROMOTIONS_FETCHING', false);
            }
        },
        async fetchUserPromotions({ commit }) {
            commit('SET_IS_PROMOTIONS_FETCHING', true);
            try {
                const res = await axios.get('/user/promotions', {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('token')}`,
                    },
                });
                console.log("User RESP Promo", res);
                commit("SET_USER_CLAIMED_PROMOTIONS", res.data.data);
            } catch (error) {
                throw new Error('Failed to fetch promotions');
            } finally {
                commit('SET_IS_PROMOTIONS_FETCHING', false);
            }
        },
        async fetchUserActivePromotions({ commit }) {
            try {
                const res = await axios.get('/user/active-promotions', {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('token')}`,
                    },
                });
                console.log("User RESP Promo", res);
                commit("SET_USER_ACTIVE_PROMOTIONS", res.data.data);
            } catch (error) {
                throw new Error('Failed to fetch promotions');
            }
        },
        async fetchUserTurnOverAmount({ commit }) {
            try {
                const res = await axios.get('/user/turn-over-amount', {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('token')}`,
                    },
                });
                console.log("RESP TURN OVER", res);
                commit("SET_TURNOVER_AMOUNT", res.data);
            } catch (error) {
                throw new Error('Failed to fetch promotions');
            }
        },
    },
    getters: {
    },
};
